<button mat-button matRipple [matRippleColor]="'white'" [color]="color" [ngClass]="buttonClass" [type]="type" [disabled]="disabled" (click)="handleClick($event)">
  <ng-content></ng-content>
  <i *ngIf="loading" class="fa fa-spinner fa-spin ml-2" aria-hidden="true"></i>
</button>
